module.exports = __webpack_public_path__ + "adb118ab2402c524eace6c7d090d71b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room7/RIST65168-1_RIST-65168.jpg
// module id = 901
// module chunks = 0